// local storage
export const IMPERSONATED_USER_ID = 'IMPERSONATED_USER_ID';
export const ORGANIZATION_ID = 'Organization-Identification';
// session storage
export const FILE_AUTH_JWT = 'FILE_AUTH_JWT';
export const CAMPAIGN_PREVIEW = 'CAMPAIGN_PREVIEW';



// WEBPACK FOOTER //
// ./src/constants/local-storage-ids.js